import { createAction } from '@reduxjs/toolkit';

import { CreditTerms, Offer } from '../../domain/qualification';

type PreapprovedPayload = {
  finalCreditLimit: CreditTerms['finalCreditLimit'];
  billingCycle: CreditTerms['billingCycle'];
  offers?: Offer[];
};

const preapproved = createAction<PreapprovedPayload>('app/preapproved');

export { preapproved };
export type { PreapprovedPayload };
